var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CpBanner',{attrs:{"src":_vm.temData.imageTextItemList[0].imageUrl,"bgColor":_vm.temData.imageTextItemList[0].backgroundColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }